import {PartnerPageShell} from "components/commons";
import {WealthyEnv} from "helpers";
import dynamic from "next/dynamic";
import React from "react";

const SipAndStepUpSipPageContent = dynamic(() => import("components/Calculators/SipAndStepUpSip"));

const SipStepUpSipPage = ({seoData}) => (
  <PartnerPageShell seoData={seoData}>
    <SipAndStepUpSipPageContent />
  </PartnerPageShell>
);

export async function getStaticProps() {
  const seoData = {
    title: "SIP Calculator for MFDs | SIP & Step-up SIP Calculator | Wealthy",
    description:
      "Use Wealthy's SIP Calculator to project SIP returns and compare Step-up SIP scenarios, helping MFDs show clients long-term wealth creation clearly.",
    keywords:
      "sip calculator, sip return calculator, sip mutual fund calculator, sip compounding calculator, sip top up calculator, sip amount calculator, step up SIP calculator",
    canonicalUrl: `${WealthyEnv.URL}/partner/calculators/sip-step-up-sip`,
    ogImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-og-image.jpg`,
    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: `${WealthyEnv.URL}`
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Calculators",
              item: `${WealthyEnv.URL}/partner/calculators`
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "SIP & Step-up SIP Calculator",
              item: `${WealthyEnv.URL}/partner/calculators/sip-step-up-sip`
            }
          ]
        },
        {
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "What is a SIP & Step-up SIP Calculator?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "A SIP calculator helps estimate the future value of regular monthly investments. The Wealthy calculator also functions as a Step-up SIP calculator, allowing distributors to demonstrate how increasing SIP contributions over time can impact a client's projected wealth."
              }
            },
            {
              "@type": "Question",
              name: "How does a Step-up SIP Calculator work?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "The Step-up SIP calculator works by considering the client's monthly SIP amount, expected annual return, investment tenure and Step-up percentage. It automatically incorporates increased future investments to estimate the projected maturity value."
              }
            },
            {
              "@type": "Question",
              name: "Is a Step-up SIP better than a regular SIP?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "For clients whose income is expected to grow, a Step-up SIP can potentially create a larger corpus than a fixed SIP because higher future contributions also benefit from compounding over longer investment horizons."
              }
            },
            {
              "@type": "Question",
              name: "How much should clients increase their SIP every year?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Many investors choose to increase their SIP by 5%-15% annually depending on salary growth, affordability and financial goals. Even modest annual increases can significantly improve long-term outcomes, which can be easily demonstrated using the SIP calculator."
              }
            },
            {
              "@type": "Question",
              name: "Can I compare different SIP scenarios using the calculator?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Yes. The Wealthy SIP calculator allows distributors to compare multiple SIP amounts, investment tenures, expected returns and Step-up percentages, helping clients choose an investment strategy aligned with their financial goals."
              }
            }
          ]
        }
      ]
    }
  };

  return {
    props: {
      seoData
    }
  };
}

export default SipStepUpSipPage;
